// ** Redux
import { createAsyncThunk } from "@reduxjs/toolkit";

// ** Helpers
import { createApiCall } from "helpers/createApiCall";

// ############################################################

export const setUserStatus = createAsyncThunk(
	"globalUser/setUserStatus",
	createApiCall(async ({ status }, client) => {
		await client.put(`/user/status?status=${status}`);

		return { status };
	})
);

// ############################################################
